import { ICityRequestType, IPostalCodeRequestType, IStateRequestType } from "./type"

const masterDataBaseUrl = "/masterdata"

export const MasterDataEndpointConst = {
    countries: `${masterDataBaseUrl}/countries`,
    branches: `${masterDataBaseUrl}/branches`,
    getDesignation: `${masterDataBaseUrl}/designation-types`,
    roles: `${masterDataBaseUrl}/roles`,
    document: `${masterDataBaseUrl}/document-types`,
    getContractStatus: `${masterDataBaseUrl}/employee-contract-status`,
    overtimeStatus: `${masterDataBaseUrl}/employee-overtime-status`,
    getLeaveType: `${masterDataBaseUrl}/leave-types`,
    salaryStatus: `${masterDataBaseUrl}/employee-salary-status`,
    leaveStatus: `${masterDataBaseUrl}/employee-leave-status`,
    resourceType: `${masterDataBaseUrl}/resource-types`,
}

export const stateUrl = (params: IStateRequestType) => {
    return `${masterDataBaseUrl}/states?countryName=${params.countryName}`
}
export const cityUrl = (params: ICityRequestType) => {
    return `${masterDataBaseUrl}/metro-cities?stateName=${params.City.stateName}`
}

export const postalCodeUrl = (params: IPostalCodeRequestType) => {
    return `${masterDataBaseUrl}/postalcode?metroCity=${encodeURIComponent(params.postCode.metroCity)}`
}